var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", [_c("mavon-editor", {
    ref: "md",
    staticStyle: {
      "min-height": "600px"
    },
    on: {
      change: _vm.change
    },
    model: {
      value: _vm.content,
      callback: function ($$v) {
        _vm.content = $$v;
      },
      expression: "content"
    }
  })], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };